import { useCityContext } from '../../../contexts/CityProvider';
import AcademiaFilterSelect from '../../CommonComps/Inputs/AcademiaFilterSelect';
import AcademiaSearchInput from '../../CommonComps/Inputs/AcademiaSearchInput';

const FilterCitiesDiv = () => {
  // integration of context hooks here
  const {
    cityAddedProvinceOptions,
    searchText,
    isResetFilter,
    setSearchText,
    setFilterProvince,
    setIsResetFilter,
  } = useCityContext();

  // rendering filter cities component here
  return (
    <div className='flex flex-col md:flex-row items-center gap-3 justify-between mb-5 bg-legal-dark-blue shadow-academia-sm rounded-lg p-3'>
      <div
        className={`bg-base-white shadow-academia-sm w-full md:w-fit rounded-lg`}
      >
        <div className='w-1/5 min-w-full md:min-w-[280px]'>
          <AcademiaSearchInput
            searchText={searchText}
            setSearchText={setSearchText}
            inputLabel='Search City...'
            removeBorder
          />
        </div>
      </div>

      <AcademiaFilterSelect
        options={['All', ...cityAddedProvinceOptions]}
        onChangeHandler={(province) => setFilterProvince(province)}
        isResetFilter={isResetFilter}
        setIsResetFilter={setIsResetFilter}
      />
    </div>
  );
};

export default FilterCitiesDiv;
